

































import Vue from "vue";

export default Vue.extend({
  props: {
    dates: {
      type: Array as () => Array<string>,
      default: () => {
        return [] as string[];
      }
    }
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    startDate: {
      get(): Date {
        return this.$store.state.sequence.startDate;
      },
      set(date: Date) {
        
      window.console.log("Start Date:" + JSON.stringify(date));
        this.$store.commit("sequence/setStartDate", date);
      },
    },
    endDate: {
      get(): Date {
        return this.$store.state.sequence.endDate;
      },
      set(date: Date) {
      window.console.log("End Date:" + JSON.stringify(date));
        this.$store.commit("sequence/setEndDate", date);
      },
    },
  },
  methods: {
    setName(event) {
      this.$store.commit("sequence/setName", event.target.value);
    },
    setEmail(event) {
      this.$store.commit("sequence/setEmail", event.target.value);
    },
  },
});
